
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/[projectId]/history/[runOrSuiteId]",
      function () {
        return require("private-next-pages/project/[projectId]/history/[runOrSuiteId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project/[projectId]/history/[runOrSuiteId]"])
      });
    }
  